export const BitbucketMarkNeutral = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.73796 10.3291C8.09296 10.3291 7.60196 10.9071 7.70596 11.5441L12.13 38.4841C12.242 39.1661 12.831 39.6661 13.521 39.6721L34.812 39.6681C35.325 39.6681 35.763 39.2961 35.845 38.7901L40.294 11.5491C40.398 10.9131 39.907 10.3351 39.262 10.3351L8.73696 10.3281L8.73796 10.3291ZM27.427 29.8001H20.606L18.79 20.1901H29.072L27.427 29.8001Z"
      fill="#758195"
    />
    <path
      d="M38.883 20.1899H29.072L27.427 29.7999H20.606L12.605 39.3269C12.605 39.3269 12.964 39.6709 13.521 39.6709L34.813 39.6669C35.325 39.6669 35.762 39.2949 35.844 38.7899L38.882 20.1899H38.883Z"
      fill="url(#paint0_linear_818_574)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_574"
        x1="41.152"
        y1="22.8799"
        x2="24.937"
        y2="35.5379"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.176" stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#758195" />
      </linearGradient>
    </defs>
  </svg>
);
